const ScrollToAnchor = () => {
const anchors = document.querySelectorAll('a[href^="#"]');
  
  if (anchors.length > 0) {
    anchors.forEach((anchor) => {
      anchor.addEventListener("click", () => {
        const targetId = anchor.getAttribute("href").substring(1);
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          targetElement.classList.add("scroll-margin-top");
        }
      });
    });
  }
}

export default ScrollToAnchor;